import { MastercardIcon, MirIcon, SbpIcon, VisaMastercardIcon } from "@/components/icons"

export function PaymentMethodIcons({ includeSbp = false }: { includeSbp?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2">
      <MirIcon />
      <VisaMastercardIcon />
      <MastercardIcon />
      {includeSbp ? <SbpIcon className="ml-2" /> : null}
    </span>
  )
}
